const totalMargins = (numOfSlides, marginRight) => {
    return ((numOfSlides - 1) * 2) * marginRight;
};
const visibleSlidesAmount = (leftOffset, rightOffset, slideWidth, marginRight) => {
    let slideAmount = 1;
    let totalMargin = 0;
    while (leftOffset + rightOffset + (slideAmount * slideWidth) + totalMargin <= window.innerWidth) {
        slideAmount += 1;
        totalMargin = totalMargins(slideAmount, marginRight);
    }
    return slideAmount -= 1;
};
const setGlidesControlWidth = (leftOffset, rightOffset, slideWidth, marginRight) => {
    const visibleSlides = visibleSlidesAmount(leftOffset, rightOffset, slideWidth, marginRight);
    let totalMargin = totalMargins(visibleSlides, marginRight);
    return visibleSlides * slideWidth + totalMargin;
};
const setButtonsVisibility = (glide, firstButton, lastButton, numOfSlides) => {
    let glideControls = glide.selector.querySelector(".block__glideControls");
    if (!glideControls) {
        return;
    }
    if (getComputedStyle(glideControls).display === "none") {
        firstButton.setAttribute("aria-hidden", "true");
        lastButton.setAttribute("aria-hidden", "true");
        return;
    } else {
        firstButton.setAttribute("aria-hidden", "false");
        lastButton.setAttribute("aria-hidden", "false");
    }

    let isLastIndex = glide.index + glide._o.perView === numOfSlides;
    if (glide.index == 0) {
        firstButton.setAttribute("aria-hidden", "true");
        firstButton.classList.add("glide__arrow--disabled");
    }
    if (glide.index != 0) {
        firstButton.setAttribute("aria-hidden", "false");
        firstButton.classList.remove("glide__arrow--disabled");
    }
    if (isLastIndex) {
        lastButton.setAttribute("aria-hidden", "true");
        lastButton.classList.add("glide__arrow--disabled");
    }
    if (!isLastIndex) {
        lastButton.setAttribute("aria-hidden", "false");
        lastButton.classList.remove("glide__arrow--disabled");
    }
};

const centerControlsOnImage = (imageHolder, glideControls) => {
    if (imageHolder) {
        glideControls.forEach(glideControl => {
            glideControl.style.height = `${imageHolder.getBoundingClientRect().height}px`;
        });
    }
}

const centerControlsOnCardContainer = (imageHolders, glideControls) => {
    if (imageHolders) {
        let tallestHeight = 0;
        imageHolders.forEach(holder => {
            let holderHeight = holder.getBoundingClientRect().height;
            if (holderHeight > tallestHeight)
                tallestHeight = holderHeight;
        });

        glideControls.forEach(glideControl => {
            glideControl.style.height = `${tallestHeight}px`;
        });
    }
}
const disableIfGlideFit = (glide) => {
    const glideControls = glide.selector.querySelector(".block__glideControls");
    const slides = glide.selector.querySelectorAll(".glide__slide:not([style*='display: none'])");
    const pixelsToLeftSideOfScreen = glide.selector.getBoundingClientRect().left;
    const pixelsToRightSideOfScreen = window.innerWidth - glide.selector.getBoundingClientRect().right < 0 ? 0 : window.innerWidth - glide.selector.getBoundingClientRect().right;
    const numOfSlides = slides.length;
    if (numOfSlides === 0) {
        console.error("The following dom element contains no slides!");
        console.error(glide.selector);
        console.error(glide.selector.parentElement);
        if (!glideControls) {
            console.error("There is no current glide control in this DOM Element!: ");
            console.error(glide.selector);
        } else {
            glideControls.style.display = "none";
        }
        return;
    }
    const oneSlideWidth = parseInt(slides[0].style.width);
    if (glideControls == null) {
        console.error("There is no current glide control in this DOM Element!: ");
        console.error(glide.selector);
        return;
    }
    let marginRight;
    let totalSlidesWidth;
    let totalMargin;
    if (numOfSlides > 1) {
        marginRight = parseInt(slides[0].style.marginRight);
        totalMargin = totalMargins(numOfSlides, marginRight);
        totalSlidesWidth = (numOfSlides * (oneSlideWidth) + totalMargin);
    } else {
        marginRight = 0;
        totalSlidesWidth = oneSlideWidth;
        totalMargin = 0;
    }
    // check if overflow
    const isOverflow = totalSlidesWidth + pixelsToLeftSideOfScreen + pixelsToRightSideOfScreen > window.innerWidth;
    // if the carousel does not overflow disable interactions (otherwise it breaks when interacted with)
    if (!isOverflow) {
        glideControls.style.display = "none";
        if (glide.index !== 0) {
            glide.go("=0");
        }
        glide.disable();
    }
    else {
        // Align the right button with the right most fully visible carousel item
        glideControls.style.display = "flex";
        glideControls.style.width = `${setGlidesControlWidth(pixelsToLeftSideOfScreen, pixelsToRightSideOfScreen, oneSlideWidth, marginRight)}px`;
        if (glide.disabled) {
            glideControls.style.display = "flex";
            glide.enable();
        }
        const firstButton = glideControls.querySelector(".button__glide.button__prev");
        const lastButton = glideControls.querySelector(".button__glide.button__next");
        setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
    }
};

// stop event bubbling for carousel glide controls 
(() => {
    const buttons = document.querySelectorAll(".button__glide");
    buttons.forEach(button => {
        button.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    });
})();
export { disableIfGlideFit, setButtonsVisibility, centerControlsOnImage, centerControlsOnCardContainer };
